import { ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

import { NotificationSeverity } from "../../shared/enums/notification-severity";

interface IProps {
  title: string;
  message: string | ReactNode;
  severity: NotificationSeverity;
  onClose: () => void;
  onSuccess: (err?: Error | null) => void;
  /** true — только кнопка подтверждения и крестик (информационное окно), без «Да»/«Нет». */
  confirmOnly?: boolean;
  confirmLabel?: string;
  isResultDialog?: boolean;
}

const DEFAULT_CONFIRM_LABEL = "ОК";
const RESULT_CONTENT_SX = { px: 6, pt: 0 };
const RESULT_ACTIONS_SX = { justifyContent: "center", pb: 3 };
const RESULT_CONFIRM_BUTTON_SX = {
  bgcolor: "primary.dark",
  color: "common.white",
  "&:hover": { bgcolor: "secondary.light" },
};

export const ConfirmDialog = (props: IProps) => {
  const {
    title,
    message,
    onSuccess,
    onClose,
    severity,
    confirmOnly = false,
    confirmLabel = DEFAULT_CONFIRM_LABEL,
    isResultDialog = false,
  } = props;

  const acknowledgeHandler = () => {
    onSuccess();
    onClose();
  };

  const cancelHandler = () => {
    onSuccess(new Error("User cancelled"));
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={cancelHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ pr: 6 }}>
        {title}
        <IconButton
          aria-label="закрыть"
          onClick={cancelHandler}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={isResultDialog ? RESULT_CONTENT_SX : undefined}>
        {typeof message === "string" ? (
          <DialogContentText
            id="alert-dialog-description"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {message}
          </DialogContentText>
        ) : (
          <div id="alert-dialog-description">{message}</div>
        )}
      </DialogContent>
      <DialogActions sx={isResultDialog ? RESULT_ACTIONS_SX : undefined}>
        {confirmOnly ? (
          <Button
            onClick={acknowledgeHandler}
            color={isResultDialog ? "primary" : severity}
            variant="contained"
            disableElevation={isResultDialog}
            sx={isResultDialog ? RESULT_CONFIRM_BUTTON_SX : undefined}
          >
            {confirmLabel}
          </Button>
        ) : (
          <>
            <Button onClick={cancelHandler} color={severity}>
              Нет
            </Button>
            <Button onClick={acknowledgeHandler} color={severity} variant="contained">
              Да
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
